import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import { menuOutline } from "ionicons/icons";
import { ReactElement } from "react";
import { useConfig } from "../../../contexts/ConfigContext";
import Icon from "../../atoms/Icon";
import Menu from "../../molecules/Menu/Menu";
import { useResonanceLayout } from "./ResonanceLayoutContext";
import ScreenTitle from "../../atoms/ScreenTitle";
import { MINI_LOGO, LOGO } from "../../../constants/images";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";

interface ResonanceLayoutProps {
  children?: ReactElement;
  isConnected?: boolean;
}

const ResonanceLayout = ({
  children,
  isConnected,
}: ResonanceLayoutProps): ReactElement => {
  const {
    disableNav,
    disableHeader,
    isMenuVisible,
    setResonanceLayout,
    backgroundColor,
    title,
    welcomePage,
    headerBackground,
  } = useResonanceLayout();

  let history = useHistory();
  const { study_slug } = useParams<{ study_slug: string }>();
  const { t } = useTranslation();

  const { app } = useConfig();

  const setIsMenuVisible = (value: boolean) => {
    setResonanceLayout({
      isMenuVisible: value,
    });
  };

  // useEffect(() => {
  //   updateManifest(app?.name, app?.logo);
  // }, [app]);

  const handleLogoClick = () => {
    history.push(`/${study_slug}/home`); // Navigate to home page
  };

return (
   <IonPage>
  {!disableHeader && welcomePage !== undefined && (
    <IonHeader className="ion-no-border">
      <WaveToolbar $headerBg={headerBackground}
      >
        <IonTitle>
          {!welcomePage && <ScreenTitle>{t(title)}</ScreenTitle>}
        </IonTitle>

        {!welcomePage && (
          <Logo
            src={MINI_LOGO}
            // onClick={handleLogoClick}
            // role="button"
            // alt="Home"
          />
        )}
        <MenuButton onClick={() => setIsMenuVisible(true)}>
          <Icon icon={menuOutline} size="large" />
        </MenuButton>
      </WaveToolbar>
    </IonHeader>
  )}

  {welcomePage && <BigLogoWrapper><BigLogo /></BigLogoWrapper>}

  <IonContent className={!disableNav ? "with-tabbar" : "no-tabbar"}
    style={{
      position: "relative",
      backgroundColor,
      display: "flex",
      flexDirection: "column",
      maxWidth: "1200px",
      margin: "0 auto",
      width: "100%",
      alignSelf: "center",
    }}
    fullscreen={true}
  >
    {children}
    {/* {isConnected && !disableNav && <NavButtons />} */}
  </IonContent>

  {isMenuVisible && (
    <Menu
      onClose={() => setIsMenuVisible(false)}
      isConnected={isConnected}
    />
  )}
</IonPage>

  );
};

const Logo = styled.img`
  position: absolute;
  max-width: 12.5%;
  max-height: 7vh;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto 0;
  // cursor: pointer;
`;

const BigLogoWrapper = styled.div`
  position: absolute;
  top: calc(25vh * (163 / 500)); /* Bottom of the toolbar */
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center; /* Center the logo horizontally */
  transform: translateY(-50%); /* Center vertically on toolbar bottom */
  z-index: 10;
  pointer-events: none;
`;


const BigLogo = styled.img.attrs({
  src: LOGO,
})`
  max-width: 18%;
  max-height: 16vh;

  @media only screen and (max-width: 480px) {
    max-height: 18vh;
    max-width: 30%;
  }
`;


const MenuButton = styled.button`
   position: absolute;
  right: 15px;
  top: 0;
  bottom: 0;
  margin: auto 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`;

const WaveToolbar = styled(IonToolbar)<{ $headerBg?: string }>`
  padding: 0;
  position: relative;
  display: flex;
  height: calc(38vh * (163 / 500));

  /* Ionic internals */
  --opacity: 0;
  --background: transparent;

  /* What you had inline */
  background-color: ${({ $headerBg }) => $headerBg};

  background-image: url("/assets/images/header-background-main.svg");
  background-position: left top;
  background-repeat: repeat-x;
  background-size: auto 100%;

  /* iOS Safari seam fix */
  @supports (-webkit-touch-callout: none) {
    background-size: auto 101.3%;
  }
`;

export default ResonanceLayout;